<input-text #filterTextBox inputId="filter-text-box" [isSearchField]="true"
            [value]="multiSelect.filterValue"
            [required]="false"
            placeHolderText="{{'multi.select.filter.placeholder' | translate}}"
            (onTextChange)="onFilterChanged($event)"
            (onSearchReset)="onFilterReset()"
></input-text>
<div class="actions" *ngIf="displaySelectOptions">
  <a class="action select-all" title='{{"multi.select.select.all" | translate}}' (click)="onSelectAll()">{{"multi.select.select.all" | translate}}</a>
  <a class="action clear-all" title='{{"multi.select.clear.all" | translate}}' (click)="onClearAll()">{{"multi.select.clear.all" | translate}}</a>
</div>

